module.exports = __webpack_public_path__ + "static/media/icon_marker_black.2ea92afe.svg";